export const mapCategorias = {
    'CDI': ['COLABORADOR', 'PROVEEDOR'],
    'REL': ['COLABORADOR'],
    'DIR': ['DIRECTOR'],
    'PATR': ['CLIENTE'],
    'GIFT': ['COLABORADOR'],
    'TRAVEL': ['COLABORADOR'],
    'FP': ['COLABORADOR'],
    'SOC': ['COLABORADOR'],
    'PEP': ['CLIENTE', 'COLABORADOR', 'PROVEEDOR', 'DIRECTOR'],
    'ODF': ['CLIENTE', 'COLABORADOR', 'PROVEEDOR', 'DIRECTOR'],
    'KYC': ['CLIENTE', 'COLABORADOR', 'PROVEEDOR', 'DIRECTOR']
};

function formTypeValidator (currentUser, categories, addAllOpt, tipoDeclaracion = null) {
  //Recibe currentUser (Global Context var)
  //Recibe categories[]

  let FORM_VALIDATOR = {


    'CDI': currentUser.modules.includes('CDI-FORM-GD') && currentUser.cliente.modules.includes('CDI-FORM-CDI') && (categories === null || categories === undefined || categories?.includes('COLABORADOR') || categories?.includes('PROVEEDOR')),
    'REL': currentUser.modules.includes('CDI-FORM-GREL') && currentUser.cliente.modules.includes('CDI-FORM-REL') && (categories === null || categories === undefined || categories?.includes('COLABORADOR')),
    'DIR': currentUser.modules.includes('CDI-FORM-GDIR') && currentUser.cliente.modules.includes('CDI-FORM-DIR') && (categories === null || categories === undefined || categories?.includes('DIRECTOR')),
    'PATR': currentUser.modules.includes('CDI-FORM-GPATR') && currentUser.cliente.modules.includes('CDI-FORM-PATR') && (categories === null || categories === undefined || categories?.includes('CLIENTE')),
    'GIFT': currentUser.modules.includes('CDI-FORM-GF-G') && currentUser.cliente.modules.includes('CDI-FORM-G') && (categories === null || categories === undefined || categories?.includes('COLABORADOR')),
    'TRAVEL': currentUser.modules.includes('CDI-FORM-GF-T') && currentUser.cliente.modules.includes('CDI-FORM-T') && (categories === null || categories === undefined || categories?.includes('COLABORADOR')),
    'FP': currentUser.modules.includes('CDI-FORM-GF-F') && currentUser.cliente.modules.includes('CDI-FORM-F') && (categories === null || categories === undefined || categories?.includes('COLABORADOR')),
    'SOC': currentUser.modules.includes('CDI-FORM-GF-S') && currentUser.cliente.modules.includes('CDI-FORM-S') && (categories === null || categories === undefined || categories?.includes('COLABORADOR')),
    'PEP': currentUser.modules.includes('FORM-PEP') && currentUser.cliente.modules.includes('FORM-PEP'),
    'ODF': currentUser.modules.includes('FORM-ODF') && currentUser.cliente.modules.includes('FORM-ODF')
  }

  if (tipoDeclaracion) {
    const tipo = tipoDeclaracion.toUpperCase();
    FORM_VALIDATOR = {
      ...FORM_VALIDATOR,
      'KYC': currentUser.modules.includes('ONBOARDING') && currentUser.cliente.modules.includes('ONBOARDING')
    }

    const hasAccess = FORM_VALIDATOR[tipo];  //categories = undefined || null evita validación por categoría
    return hasAccess ? mapCategorias[tipo] || [] : [];
  }


  let validatedTypes = []

    for (let type in FORM_VALIDATOR){
      if(FORM_VALIDATOR[type]){
        validatedTypes.push(type)
      }
    }
    if(addAllOpt){
      validatedTypes.unshift('ALL')
    }

    return validatedTypes;
  }

export default formTypeValidator;